<template>
    <v-row justify="center" align-content="center" align="center">          
        <v-col order="1" order-md="2" order-lg="2" order-xl="2" class="text-center col-xs-12">
            <div id="jitsi-container"/>
        </v-col>          
    </v-row>
</template>
<script src='https://meet.jit.si/external_api.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>
import * as firebase from "firebase"
import presentear from "@/components/presentearComponent"
import mensagem from "@/components/messagePage"
import preRevelation from "./preRevelation"
import {db} from '@/main.js'

export default {
    components:{presentear,mensagem, preRevelation},
    props: ['babyData'],
    data: () => ({
        url: '',
        babyData: '',
        key: 0,
        db: '',
        contagem: new Date().getTime(),
        votosMenino: 0,
        votosMenina: 0,
        loading: false,
        finalizado: false,
        room: '',
        userName: '',
        revelaType: '',
        sexo: '',
        nomeReal: '',
        revelationId: '',
        encerrado: false,
        ct2: new Date().getTime() + 7200000,       
    }),     
    async created(){
      await setTimeout(()=>{}, 5000);
      this.url = this.babyData.URL;
      this.startCha()

    },
    methods:{
        async startCha(){
            this.finalizado = true
            await this.loadVotos()
            this.startConference();          
        },      
        async loadVotos(){
            await db.collection('revelacoes').where('URL','==',this.url).get()
            .then((seg) => {    
                this.votosMenino = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a[0].votosMenino || 0});                    
                this.votosMenina = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a[0].votosMenina || 0});                                    
            }).catch(function (error) {
                console.error("Error get Votos: ", error);
            }); 
        },
        startConference() {
            // var _this=this
            try {
                const domain = 'meet.jit.si';
                const options = {
                    audioInput: '<deviceLabel>',
                    audioOutput: '<deviceLabel>',
                    videoInput: '<deviceLabel>',
                    roomName: this.url,
                    // height: 500,
                    parentNode: document.querySelector('#jitsi-container'),
                    interfaceConfigOverwrite: {
                        filmStripOnly: false,
                        SHOW_JITSI_WATERMARK: false,
                    },
                    configOverwrite: {
                        disableSimulcast: false,
                    },
                    userInfo: {
                        email: 'email@jitsiexamplemail.com',
                        displayName: 'this.userName'
                    }                    
                };

                this.api = new JitsiMeetExternalAPI(domain, options);
                // this.api.addEventListener('videoConferenceJoined', () => {
                //    console.log('Local User Joined');        
                //     this.api.executeCommand('displayName', this.userName);
                // });
            } catch (error) {
                console.error('Failed to load Jitsi API', error);
            }
        },                 
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Share+Tech+Mono');

#teste-template {
  height: 100% !important;
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;
}
#teste-template-f {
  height: 100% !important;
  background: #f59cd3;
  /* background-size: cover; */
}
#teste-template-m {
  height: 100% !important;
  background: #51c7fd;
  /* background-size: cover; */
}

#jitsi-container {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
}
.font-crono {
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 5em;
    line-height: 1;
} 

@media (max-width: 380px) {
    .font-crono {
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em;
        line-height: 1;
    }; 
    .font-crono-span{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em!important;
        color: rgb(196, 29, 29)!important
    }
    .font-crono-span2{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 2.3em!important;
        color: white!important    
    }        
}

.font-crono-span{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 0.27em!important;
    color: white!important
}
.font-crono-span2{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 4.3em!important;
    color: white!important    
}

.font-crono-span-revela{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 2.3em!important;
    color: white!important    
}
.transparent {
   background-color: white!important;
   opacity: 0;
   border-color: transparent!important;
}
.font-white{
       color: white!important;
}

 .share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF !important;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>